import React, { useRef, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Header from './Components/home/Header';
import Footer from './Components/home/Footer';
import SmartAppInstall from '../../Components/SmartAppInstall';
import './NotFoundPage.css';

const IconProperties = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
    <line x1="12" y1="12" x2="12" y2="16" />
    <line x1="10" y1="14" x2="14" y2="14" />
  </svg>
);

const NotFoundPage = () => {
  const codeRef = useRef(null);
  const [codeHover, setCodeHover] = useState(false);
  const [glowPos, setGlowPos] = useState({ x: 0, y: 0 });

  const handleCodeMouseMove = useCallback((e) => {
    const el = codeRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    setGlowPos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  }, []);

  return (
    <main className="nf-page">
      <div className="nf-glow nf-glow--tl" aria-hidden="true" />
      <div className="nf-glow nf-glow--br" aria-hidden="true" />

      <div className="nf-card">
        <div
          ref={codeRef}
          className={`nf-code-block${codeHover ? ' nf-code-block--hover' : ''}`}
          aria-hidden="true"
          onMouseEnter={() => setCodeHover(true)}
          onMouseLeave={() => setCodeHover(false)}
          onMouseMove={handleCodeMouseMove}
        >
          <span
            className="nf-cursor-glow"
            style={{ left: glowPos.x, top: glowPos.y }}
            aria-hidden="true"
          />
          <span className="nf-digit nf-digit--left">4</span>
          <span className="nf-digit nf-digit--zero">0</span>
          <span className="nf-digit nf-digit--right">4</span>
        </div>

        <div className="nf-divider" aria-hidden="true" />

        <div className="nf-copy">
          <p className="nf-eyebrow">Error 404</p>
          <h1 className="nf-title">Page not found</h1>
          <p className="nf-desc">
            The link may be broken or the page may have been removed.
            Return home or browse our property listings.
          </p>
        </div>

        <div className="nf-actions">
          <Link to="/" className="nf-btn nf-btn-primary">
            Back to Home
          </Link>
          <Link to="/properties" className="nf-btn nf-btn-outline">
            <span className="nf-btn-icon"><IconProperties /></span>
            <span>Browse Properties</span>
          </Link>
        </div>
      </div>
    </main>
  );
};

/** Full-page 404 with header/footer for routes outside MyLayout */
export const NotFoundWithSiteChrome = () => (
  <>
    <Header />
    <NotFoundPage />
    <Footer />
    <SmartAppInstall />
  </>
);

export default NotFoundPage;
